import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAntena3Component } from './simple-icons-antena3.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAntena3Component ],
    exports:      [ SimpleIconsAntena3Component ],
    bootstrap:    []
})
export class SimpleIconsAntena3Module {}
